import React, { useMemo } from 'react';
import { batch } from 'react-redux';
import styled from 'styled-components';
import {
  IBuilderMergeEvent,
  IRowMeta,
  removeErrorAction,
  removeReroutingEventAction,
  RowType,
} from '../../../../../redux/slices/oldBuilder';
import { EventConditions } from '../../EventConditions';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import {
  eventConditionsPrimitiveSelector,
  rowSelector,
} from '../../../../../redux/selectors/builder';
import MergeEventAlias from './MergeEventAlias';
import { IEventConditionFieldsFragment } from '../../../../../utils/apollo/graphqlSchema';
import ThinDivider from '../../../../ThinDivider';

interface IProps {
  index: number;
}

const Container = styled.div`
  display: grid;
  grid-template-columns: minmax(400px, 1fr) auto 300px;
  align-items: center;
  column-gap: 16px;
`;

const VerticalDivider = styled.div`
  height: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
`;

const MergeEventInput = ({ index }: IProps) => {
  const dispatch = useAppDispatch();

  const rowMeta: IRowMeta = {
    rowType: RowType.mergeEvents,
    rowIndex: index,
  };

  const eventConditionsSelector = useMemo(eventConditionsPrimitiveSelector, []);
  const eventConditions: IEventConditionFieldsFragment[] = useAppSelector(
    (state) => eventConditionsSelector(state, rowMeta),
  );

  const mergeEvent: IBuilderMergeEvent =
    useAppSelector((state) => rowSelector(state, rowMeta)) ?? {};

  const { isNameAutoGenerated, name } = mergeEvent;

  const handleRemoveEventCondition = () => {
    // Special case: removing a single event condition will remove Merge event
    batch(() => {
      dispatch(removeErrorAction({ rowMeta, errorKey: '', clearRow: true }));
      dispatch(
        removeReroutingEventAction({
          index,
          type: RowType.mergeEvents,
        }),
      );
    });
  };

  return (
    <Container>
      <EventConditions
        rowMeta={rowMeta}
        label={'Merge Event(s)'}
        onRemoveCondition={
          eventConditions.length === 1 ? handleRemoveEventCondition : undefined
        }
      />
      <VerticalDivider>
        <ThinDivider layout="vertical" size="full" />
      </VerticalDivider>
      <MergeEventAlias
        rowMeta={rowMeta}
        isNameAutoGenerated={isNameAutoGenerated}
        name={name}
      />
    </Container>
  );
};

export default MergeEventInput;
